import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import '../css/Footer.less';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';

import BannerService from '../services/BannerService';

const Footer = observer((props) => {
  const { t } = props;

  let { 
    footerLinkMap, 
    logoInfo, 
    showMinimalFooter = false,
    contactEmail,
    contactPhone,
    copyrightText
  } = props;

  const { /* managers */ } = useContext(MobXProviderContext);

  footerLinkMap = footerLinkMap || BannerService.generateFooterLinkMap();
  logoInfo = logoInfo || BannerService.getLogoInfo();
  
  const contactInfo = BannerService.getContactInfo ? BannerService.getContactInfo() : {};
  contactEmail = contactEmail || contactInfo.email;
  contactPhone = contactPhone || contactInfo.phone;
  copyrightText = copyrightText || (BannerService.getCopyrightText ? BannerService.getCopyrightText() : '');

  const Logo = SatCoreComponent('Logo');

  const renderFooterElement = (element) => {
    switch (element) {
      case 'contact':
        return contactEmail ? (
          <a href={`mailto:${contactEmail}`} className='footer-link'>
            Contact Us
          </a>
        ) : null;
      
      case 'phone':
        return contactPhone ? (
          <span className='footer-phone'>{contactPhone}</span>
        ) : null;
      
      case 'separator':
        return <span className='footer-separator'>|</span>;
      
      case 'logo':
        return logoInfo ? (
          <div className='footer-logo'>
            <Logo
              ariaLabel='Logo'
              logoImg={logoInfo.logoImg}
              logoUrl={logoInfo.logoUrl}
              navButton />
          </div>
        ) : null;
      
      default:
        const link = footerLinkMap.get(element);
        return link ? (
          <a className='footer-link'
            href={link}
            rel='noreferrer noopener'
            target='_blank'>
            {t(element)}
          </a>
        ) : null;
    }
  };

  // Minimal footer layout
  if (showMinimalFooter) {
    const footerElements = BannerService.generateFooterElements ? BannerService.generateFooterElements() : [];
    
    return (
      <div className='satellite-footer minimal-footer'>
        <div className='footer-row-1'>
          {footerElements.map((element, index) => (
            <React.Fragment key={`footer-element-${index}`}>
              {renderFooterElement(element)}
            </React.Fragment>
          ))}
        </div>
        {copyrightText && (
          <div className='footer-row-2'>
            <div className='footer-copyright'>
              {copyrightText}
            </div>
          </div>
        )}
      </div>
    );
  }

  // Original three-column layout
  return (
    <div className='satellite-footer'>
      <div className='footer-left'>
        {Array.from(footerLinkMap?.entries() || []).map(([linkKey, link]) => {
          return (
            <div key={linkKey} className='footer-link-wrapper'>
              <a className='footer-link'
                href={link}
                rel='noreferrer noopener'
                target='_blank'>
                {t(linkKey)}
              </a>
            </div>
          );
        })}
      </div>
      <div className='footer-mid'>
        {/* placeholder */}
      </div>
      <div className='footer-right'>
        {logoInfo && (
          <Logo
            ariaLabel='Logo'
            logoImg={logoInfo.logoImg}
            logoUrl={logoInfo.logoUrl}
            navButton />
        )}
      </div>
    </div>
  );
});
export default Footer;

SatCoreRegister('Footer', Footer);
